import type { User, UserRoleName } from '~/types/user.type'

export function userRoles(user: User) {
  return Object.fromEntries(user.roles.map(({ name }) => [name, true])) as { [role in UserRoleName]?: true }
}
